import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";

const vUI_DataObject_Search_Fields: {[id:string]: ISearchProviderField } =
    {
        WB_DATAOBJECT_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'DataObject WB Id',  columnResourceName: 'colDataObjectWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
        DATAOBJECT_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'DataObject Id',     columnResourceName: 'colDataObjectId',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
        DATAOBJECT_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'DataObject Name',   columnResourceName: 'colDataObjectName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
        DATAOBJECT_TYPE:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Level',           columnResourceName: 'colLevel',         alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
        TREE_PATH:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tree Path', columnResourceName: 'colTreePath', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
        CREATED_DTTS: {
            type: SearchProviderFieldType.sapdate,
            renderOptions: {
                columnName: 'Created Date',
                columnResourceName: 'colCreateDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM-dd-yy"
            },
            domainOptions: {}
        },
        MODIFIED_DTTS: {
            type: SearchProviderFieldType.sapdate,
            renderOptions: {
                columnName: 'Modified Date',
                columnResourceName: 'colModifiedDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM-dd-yy"
            },
            domainOptions: {}
        }
    }

const DataObjectSearchProviderBasic: ISearchProvider =
    {
        keyFields: {id:    'WB_DATAOBJECT_ID',
            id_ui: 'DATAOBJECT_ID',
            name:  'DATAOBJECT_NAME'},


        searchProviderFields: vUI_DataObject_Search_Fields,

        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_DataObject_Search',
                    this.searchProviderFields,
                    [])

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(res)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        }

    }


const DataObjectSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "DataObjectSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'DataObject Id',     searchProviderFieldId: 'DATAOBJECT_ID',   renderOptions: { }},
        {profileFilterName: 'DataObject Name',   searchProviderFieldId: 'DATAOBJECT_NAME', renderOptions: { }},
    ],  // ISearchFields
    profileDisplayFields: [
        'DATAOBJECT_ID','DATAOBJECT_NAME','DATAOBJECT_TYPE', 'TREE_PATH',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: DataObjectSearchProviderBasic,
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "default",    //string;
    profileSorts: [] //ISearchSort[];
}

const DataObjectSearch: ISearch = {
    searchName: "Find Data Object",
    renderOptions: { ui5ResourceId: "DataObjectSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [DataObjectSearchProfileByName]

}

PAEnvironment.registerBusinessObjectSearch("DataObjectBO", "DataObject", DataObjectSearch, "DataObject Search")

export {DataObjectSearch}